import { useState } from "react";
import Link from "next/link";

// Cookie notice. It is in the static HTML, so it shows from the first paint (the old react-cookie-consent
// banner only appeared after the page code ran, which made it Lighthouse's late "Largest Contentful Paint").
// Visitors who already chose are hidden before paint by pages/_document.js (html[data-cookies]).
// Same cookie name and values as the old banner, so nobody is asked again.
const COOKIE = "myAwesomeCookieName2";
const MAX_AGE = 150 * 24 * 60 * 60; // 150 days, as before

export default function CookieCom() {
  const [done, setDone] = useState(false);

  const choose = (accepted) => {
    document.cookie = `${COOKIE}=${accepted}; max-age=${MAX_AGE}; path=/; SameSite=Lax`;
    document.documentElement.setAttribute("data-cookies", "set");
    setDone(true);
  };

  if (done) return null;

  return (
    <div className="cookie-bar" role="region" aria-label="Cookie notice">
      <p className="cookie-text">
        We use cookies to provide and improve our services. By using our site, you consent to cookies.{" "}
        <Link href="/privacy-policy" prefetch={false}>Privacy Policy</Link>
      </p>
      <div className="cookie-actions">
        <button type="button" className="cookie-decline" onClick={() => choose(false)}>Decline</button>
        <button type="button" className="cookie-accept" onClick={() => choose(true)}>Accept</button>
      </div>
    </div>
  );
}
